import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "padh20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_doc_link = _resolveComponent("doc-link")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_stack_layout = _resolveComponent("stack-layout")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "text-left"
  }, {
    default: _withCtx(() => [
      (_ctx.documents?.length)
        ? (_openBlock(), _createBlock(_component_stack_layout, {
            key: 0,
            orientation: "vertical",
            gap: 20,
            class: "flex-node-col"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { class: "flex-node-col" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card_header, { class: "k-hstack section" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.localize('Documents')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card_body, { class: "flex-item-scroll" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_stack_layout, {
                        orientation: "vertical",
                        align: { horizontal: 'start' },
                        gap: 5
                      }, {
                        default: _withCtx(() => [
                          (_ctx.otherDocsNames.length)
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 0,
                                class: "fw"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_card_header, { class: "label" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.localize('latestDocuments')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_card_body, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherDocsNames, (doc) => {
                                        return (_openBlock(), _createBlock(_component_doc_link, {
                                          class: "doc-spacing",
                                          key: doc.blobName,
                                          doc: doc
                                        }, null, 8, ["doc"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.adminDocsNames.length)
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 1,
                                class: "fw"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_card_header, { class: "label" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.localize('latestDocuments')) + " (" + _toDisplayString(_ctx.localize('adminData')) + ")", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_card_body, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminDocsNames, (doc) => {
                                        return (_openBlock(), _createBlock(_component_doc_link, {
                                          class: "doc-spacing",
                                          key: doc.blobName,
                                          doc: doc
                                        }, null, 8, ["doc"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.userManualNames.length)
                            ? (_openBlock(), _createBlock(_component_card, {
                                key: 2,
                                class: "fw"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_card_header, { class: "label" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_card_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.localize('originalDocument')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_card_body, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userManualNames, (doc) => {
                                        return (_openBlock(), _createBlock(_component_doc_link, {
                                          class: "doc-spacing",
                                          key: doc.blobName,
                                          doc: doc
                                        }, null, 8, ["doc"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.localize('notAvailableYet')), 1))
    ]),
    _: 1
  }, 8, ["hasLoaded"]))
}